// assets/bmx-products-carousel.js
document.addEventListener("DOMContentLoaded", () => {
  // match either your old or new blog-body wrapper
  const contentEl = document.querySelector(
    ".article-template__content.rte, .article-body .article-content"
  );
  if (!contentEl) return;

  // replace the shortcode with our carousel HTML
  contentEl.innerHTML = contentEl.innerHTML.replace(
    /\[collection-carousel="(.*?)"\](<br\s*\/?>)?/g,
    (_, handle) => {
      const id = "bmxCarousel_" + Math.random().toString(36).substr(2, 9);
      return `
<section class="bmx-prod-slider-wrapper">
  <div class="bmx-prod-slider-carousel">
    <div class="swiper-container">
      <!-- this is the Swiper wrapper! -->
      <div id="${id}" class="bmx-prod-carousel swiper-wrapper" data-collection="${handle}">
        <!-- slides get injected here -->
      </div>
    </div>
  </div>
</section>`;
    }
  );

  // for each carousel, fetch its products and build slides
  contentEl.querySelectorAll(".bmx-prod-carousel[data-collection]").forEach(wrapper => {
    const handle = wrapper.dataset.collection;
    fetch(`/collections/${handle}/products.json?limit=10`)
      .then(r => r.json())
      .then(json => {
        let html = "";
        json.products.forEach(p => {
          const img = p.images[0]?.src || "";
          const price = p.variants[0]?.price ? `$${p.variants[0].price}` : "";
          html += `
  <div class="swiper-slide bmx-prod-slide" style="background-image:url('${img}')">
    <div class="bmx-prod-title">${p.title}</div>
    <div class="bmx-prod-price">${price}</div>
    <a href="/products/${p.handle}" class="bmx-prod-btn">BUY NOW</a>
  </div>`;
        });
        wrapper.innerHTML = html;

        // now initialize Swiper on *that* container
        const swiperContainer = wrapper.closest(".swiper-container");
        new Swiper(swiperContainer, {
          slidesPerView: "auto",
          freeMode: true,
          spaceBetween: 12,
          loop: false,
          navigation: false,
          pagination: false
        });
      })
      .catch(e => console.error("BMX carousel error:", e));
  });
});
